import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TimePeriod} from '../../../classes/TimePeriod';

@Component({
  selector: 'app-timeperiod-edit',
  styleUrls: ['./timeperiod-edit.component.scss'],
  templateUrl: './timeperiod-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TimeperiodEditComponent implements OnInit {

  @Input() timePeriod: TimePeriod;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;

  public timePeriodForm: FormGroup;

  constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    if (this.timePeriod) {
      this.timePeriodForm = this.formBuilder.group({
        id: [this.timePeriod.id],
        name: [this.timePeriod.name, Validators.required],
        monday: [this.timePeriod.monday, Validators.required],
        tuesday: [this.timePeriod.tuesday, Validators.required],
        wednesday: [this.timePeriod.wednesday, Validators.required],
        thursday: [this.timePeriod.thursday, Validators.required],
        friday: [this.timePeriod.friday, Validators.required],
        saturday: [this.timePeriod.saturday, Validators.required],
        sunday: [this.timePeriod.sunday, Validators.required],
        startTime: [this.timePeriod.startTime, Validators.required],
        endTime: [this.timePeriod.endTime, Validators.required]
      });
    } else {
      this.timePeriodForm = this.formBuilder.group({
        id: [''],
        name: ['', Validators.required],
        monday: [true, Validators.required],
        tuesday: [true, Validators.required],
        wednesday: [true, Validators.required],
        thursday: [true, Validators.required],
        friday: [true, Validators.required],
        saturday: [true, Validators.required],
        sunday: [true, Validators.required],
        startTime: ['00:00:00', Validators.required],
        endTime: ['23:59:59', Validators.required]
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
